<template>
  <div class="my-2 flex justify-between items-center text-gray-600 text-xs">
    <p class="text-sm font-semibold text-gray-900 mb-2">{{ titlePath.title }}</p>
    <button
      @click="schmitzStore.goBack()"
      class="flex items-center px-2 py-1 text-gray-600 text-xs font-light hover:underline"
    >
      <svg class="arrow-icons mx-2">
        <FontAwesomeIcon icon="fa-solid fa-arrow-left" />
      </svg>
      Zurück
    </button>
  </div>
  <div v-if="schmitzStore.currentStepKey === 'accident'" class="flex flex-wrap gap-x-2 gap-y-2">
    <label
      for="unfallfrei"
      :class="{
        'bg-white hover:bg-gray-200': currentStepPath.accident,
        'bg-blue-600 text-white': !currentStepPath.accident
      }"
      class="flex flex-col items-center px-2 py-1 justify-center shadow w-fit h-full border border-gray-300 rounded cursor-pointer"
    >
      <input
        type="radio"
        id="unfallfrei"
        v-model="currentStepPath.accident"
        :value="false"
        class="hidden"
      />
      Unfallfrei
    </label>
    <label
      for="accident"
      :class="{
        'bg-white hover:bg-gray-200': !currentStepPath.accident,
        'bg-blue-600 text-white': currentStepPath.accident
      }"
      class="flex flex-col items-center px-2 py-1 justify-center shadow w-fit h-full border border-gray-300 rounded cursor-pointer"
    >
      <input
        type="radio"
        id="accident"
        v-model="currentStepPath.accident"
        :value="true"
        class="hidden"
      />
      Fahrzeug hatte einen Unfall
    </label>

    <div v-show="currentStepPath.accident" class="flex flex-wrap gap-x-2 gap-y-2 w-full">
      <label for="accident-text" class="w-full">
        Bitte beschreiben Sie den Unfall:
        <textarea
          id="accident-text"
          v-model="currentStepPath.accidentDescription"
          class="form-input w-full mt-1"
        ></textarea>
      </label>
    </div>
  </div>

  <div v-else-if="schmitzStore.currentStepKey === 'damage'" class="flex flex-wrap gap-x-2 gap-y-2">
    <template v-if="currentStepPath">
      <label
        for="notDamaged"
        :class="{
          'bg-white hover:bg-gray-200': currentStepPath[schmitzStore.currentStepKey],
          'bg-blue-600 text-white': !currentStepPath[schmitzStore.currentStepKey]
        }"
        class="flex flex-col items-center px-2 py-1 justify-center shadow w-fit h-full border border-gray-300 rounded cursor-pointer"
      >
        <input
          type="radio"
          id="notDamaged"
          v-model="currentStepPath[schmitzStore.currentStepKey]"
          :value="false"
          class="hidden"
        />
        Keine Beschädigungen
      </label>
      <label
        for="damaged"
        :class="{
          'bg-white hover:bg-gray-200': !currentStepPath[schmitzStore.currentStepKey],
          'bg-blue-600 text-white': currentStepPath[schmitzStore.currentStepKey]
        }"
        class="flex flex-col items-center px-2 py-1 justify-center shadow w-fit h-full border border-gray-300 rounded cursor-pointer"
      >
        <input
          type="radio"
          id="damaged"
          v-model="currentStepPath[schmitzStore.currentStepKey]"
          :value="true"
          class="hidden"
        />
        Fahrzeug ist Beschädigt
      </label>

      <div
        v-show="currentStepPath[schmitzStore.currentStepKey]"
        class="flex flex-wrap gap-x-2 gap-y-2 w-full"
      >
        <label for="damage-text" class="w-full">
          Bitte beschreiben Sie die Beschädigungen:
          <textarea
            type="text"
            id="damage-text"
            v-model="currentStepPath.damageDescription"
            class="form-input w-full mt-1"
          ></textarea>
        </label>
      </div>
    </template>
  </div>
  <div class="flex justify-end py-4">
    <button
      @click="schmitzStore.nextSelection()"
      :disabled="
        (currentStepPath.accident && !currentStepPath.accidentDescription) ||
        (currentStepPath.damage && !currentStepPath.damageDescription)
      "
      :class="[
        (currentStepPath.accident && !currentStepPath.accidentDescription) ||
        (currentStepPath.damage && !currentStepPath.damageDescription)
          ? 'bg-gray-200 text-gray-500 cursor-not-allowed'
          : 'bg-blue-600 text-white font-semibold shadow-md hover:bg-blue-800'
      ]"
      class="ml-4 flex items-center border rounded shadow px-2 py-1"
    >
      Weiter
    </button>
  </div>
</template>

<script setup>
import { computed, watch } from 'vue'
import { useSchmitzStore } from '@/stores/schmitzStore'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

const schmitzStore = useSchmitzStore()

let titlePath = computed(() => {
  return schmitzStore.accordion[schmitzStore.currentExpandedKey].steps[schmitzStore.currentStepKey]
})

let currentStepPath = computed(() => {
  return schmitzStore.accordion[schmitzStore.currentExpandedKey].steps[schmitzStore.currentStepKey]
    .selectedOption
})
watch(
  () => currentStepPath,
  (newValue) => {
    if (!newValue.accident) {
      newValue.accidentDescription = ''
    }
  },
  { deep: true }
)

watch(
  () => currentStepPath,
  (newValue) => {
    if (!newValue.damage) {
      newValue.damageDescription = ''
    }
  },
  { deep: true }
)
</script>
